import { Flex, Card, CardHeader, CardBody, Image, Text, Box, Link } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { IoChatbubble } from 'react-icons/io5';
import { BsBoxSeam } from 'react-icons/bs';
import { FaInstagram } from 'react-icons/fa';
import kakao01 from '../assets/images/kakao01.png';
import goods01 from '../assets/images/goods01.png';

const LinkButton = ({ icon: Icon, text, href, disabled }) => (
  <Box
    as={href && !disabled ? 'a' : 'div'}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    display="flex"
    alignItems="center"
    bg={disabled ? 'gray.50' : 'white'}
    border="1.5px solid"
    borderColor={disabled ? 'gray.100' : 'gray.200'}
    borderRadius="xl"
    px={4}
    py={3}
    cursor={disabled ? 'default' : 'pointer'}
    transition="all 0.15s"
    _hover={!disabled && { bg: 'gray.50', borderColor: 'gray.300' }}
  >
    <Box mr={3} color={disabled ? 'gray.300' : 'gray.600'} display="flex" alignItems="center">
      <Icon size={18} />
    </Box>
    <Text flex="1" fontSize="sm" fontWeight="medium" color={disabled ? 'gray.400' : 'gray.700'}>
      {text}
    </Text>
    <ChevronRightIcon color={disabled ? 'gray.300' : 'gray.400'} />
  </Box>
);

function DodoDotStudio() {
  return (
    <Flex direction="column" alignItems="center" flex="1" py={6} px={4} gap={5}>

      {/* 인스타그램 바로가기 */}
      <Link
        href="https://www.instagram.com/dododot_studio?igsh=Z2oyNTAyM3dwdzVl&utm_source=qr"
        isExternal
        display="flex"
        alignItems="center"
        gap={2}
        color="white"
        fontWeight="semibold"
        fontSize="sm"
        opacity={0.9}
        _hover={{ opacity: 1, textDecoration: "none" }}
      >
        <FaInstagram size={18} />
        @dododot_studio
      </Link>

      {/* 카카오톡 이모티콘 */}
      <Card
        maxW="sm"
        width="100%"
        overflow="hidden"
        borderRadius="2xl"
        boxShadow="0 8px 32px rgba(0,0,0,0.18)"
        border="none"
        transition="all 0.25s ease"
        _hover={{ transform: "translateY(-4px)", boxShadow: "0 16px 48px rgba(0,0,0,0.25)" }}
      >
        <Image src={kakao01} alt="카카오톡 이모티콘" />
        <CardHeader pb={1}>
          <Text fontSize="xl" fontWeight="bold">카카오톡 이모티콘</Text>
          <Text fontSize="sm" color="gray.500">세상의 모든 핑크</Text>
        </CardHeader>
        <CardBody pt={2} pb={4}>
          <LinkButton icon={IoChatbubble} text="카카오톡 이모티콘 바로가기" href="https://e.kakao.com/t/pink-pixel-deco-girl" />
        </CardBody>
      </Card>

      {/* 굿즈 */}
      <Card
        maxW="sm"
        width="100%"
        overflow="hidden"
        borderRadius="2xl"
        boxShadow="0 8px 32px rgba(0,0,0,0.18)"
        border="none"
        transition="all 0.25s ease"
        _hover={{ transform: "translateY(-4px)", boxShadow: "0 16px 48px rgba(0,0,0,0.25)" }}
      >
        <Image src={goods01} alt="굿즈" />
        <CardHeader pb={1}>
          <Text fontSize="xl" fontWeight="bold">굿즈</Text>
          <Text fontSize="sm" color="gray.500">도도닷 캐릭터 굿즈</Text>
        </CardHeader>
        <CardBody pt={2} pb={4}>
          <LinkButton icon={BsBoxSeam} text="굿즈 준비중" disabled />
        </CardBody>
      </Card>

    </Flex>
  );
}

export default DodoDotStudio;
